var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{directives:[{name:"show",rawName:"v-show",value:(_vm.showData),expression:"showData"}],staticClass:"network-background",attrs:{"x":_vm.calculateX,"y":_vm.y,"width":_vm.calculateWidth,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }